module.exports = __webpack_public_path__ + "img/169-1690450_torn-paper-png-efecto-de-hoja-rota-transparent.4db45d35.png";